// extracted by mini-css-extract-plugin
module.exports = {"priceTag":"pricetag-module--priceTag--1mJqG"};